/*global angular, navigator*/

export default function ClickOutside($document, $parse, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        link: function($scope, elem, attr) {

            // postpone linking to next digest to allow for unique id generation
            $timeout(function() {
                const classList = (attr.outsideIfNot !== angular.isUndefined) ? attr.outsideIfNot.split(/[ ,]+/) : [];
                let fn;
                /* eslint-disable */
                function eventHandler(event) {
                    /* eslint-disable */
                    let i;
                    let element;
                    let regx;
                    let id;
                    let classNames;
                    let length;

                    // check if our element already hidden and abort if so
                    if (angular.element(elem).hasClass('ng-hide')) {
                        return;
                    }

                    // if there is no click target, no point going on
                    if (!event || !event.target) {
                        return;
                    }
                 
                    

                    // loop through the available elements, looking for classes in the class list that might match and so will eat
                    for (element = event.target; element; element = element.parentNode) {
                        // check if the element is the same element the directive is attached to and exit if so
                        if (element === elem[0]) {
                            return;
                        }
                        
                        // now we have done the initial checks, start gathering id's and classes
                        id = element.id,
                            classNames = element.className,
                            length = classList.length;
                        // this is set to ensure basket doesn't close when removing items.
                        if(angular.isDefined(classNames) && classNames == 'item-remove'){
                            return;
                        }
                        
                        // Unwrap SVGAnimatedString classes
                        if (classNames && classNames.baseVal !== angular.isUndefined) {
                            classNames = classNames.baseVal;
                        }

                        // if there are no class names on the element clicked, skip the check
                        if (classNames || id) {
                            // loop through the elements id's and classnames looking for exceptions
                            for (i = 0; i < length; i++) {
                                //prepare regex for class word matching
                                regx = new RegExp('\\b' + classList[i] + '\\b');
                                // check for exact matches on id's or classes, but only if they exist in the first place
                                if ((id !== angular.isUndefined && regx.test(id)) || (classNames && regx.test(classNames))) {
                                    // now let's exit out as it is an element that has been defined as being ignored for clicking outside
                                    return;
                                }
                            }
                        }
                    }

                    // if we have got this far, then we are good to go with processing the command passed in via the click-outside attribute
                    $timeout(function() {
                        fn = $parse(attr.clickOutside);
                        fn($scope, {event: event});
                    });
                }

                // if the devices has a touchscreen, listen for this event
                if (_hasTouch()) {
                    $document.on('touchstart', function() {
                        setTimeout(eventHandler);
                    });
                }

                // still listen for the click event even if there is touch to cater for touchscreen laptops
                $document.on('click', eventHandler);
                $document.on('focusout', eventHandler);
                $document.off('blur', eventHandler);

                // when the scope is destroyed, clean up the documents event handlers as we don't want it hanging around
                $scope.$on('$destroy', function() {
                    if (_hasTouch()) {
                        $document.off('touchstart', eventHandler);
                    }

                    $document.off('click', eventHandler);
                    $document.off('focusout', eventHandler);
                    $document.off('blur', eventHandler);
                });

                /**
                 * @description Private function to attempt to figure out if we are on a touch device
                 * @private
                 **/
                function _hasTouch() {
                    // works on most browsers, IE10/11 and Surface
                    return 'ontouchstart' in window || navigator.maxTouchPoints;
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/clickOutside.directive.js